/** @file clipDuration: a clip's length in seconds (frames / fps). */
import type { Clip } from '@zilo/pose3d-format/types/clip';

/** `frames / fps`; 0 when `fps` is not positive. */
export function clipDuration(clip: Pick<Clip, 'frames' | 'fps'>): number {
  return clip.fps > 0 ? clip.frames / clip.fps : 0;
}
